import { AssetSvg } from "../../assets";
import { useAppSelector, VRIAppStateType } from "../../core";
import { shallowEqual } from "react-redux";
import { AppConstants } from "../../configs";
import { APISchemaRelease, APISchemaChange, ChangelogChangeType } from '../../models/api';

type Props = {
    release: APISchemaRelease;
    setRelease: (value: APISchemaRelease | null) => void;
    setReleaseModalShow: (value: boolean) => void;
};

const formatDate = (date: string): string => {
    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
        return "Invalid date";
    }

    return parsedDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
};


export function ChangelogBox(props: Props) {

    const { release, setRelease, setReleaseModalShow } = props;
    const data = useAppSelector(
        (state: VRIAppStateType) => ({
            isLoggedIn: state.auth.isLoggedIn,
            role: state.auth.profile?.userRole,
            videoCallStatus: state.videoCall.CallStatus,
        }),
        shallowEqual
    );

    return (
        <div className="changelog-card">
            <div className="mb-2 d-flex align-items-start justify-content-between">
                <div>
                    <h3 className="changelog-version">{release.version}</h3><span className="changelog-date">{formatDate(release.releaseDate)}</span>
                </div>
                {data.isLoggedIn && data.role === AppConstants.UserRoles.Admin ? (
                    <button
                        className="btn btn-link px-0 text-site btn-sm svg-color"
                        style={{ height: "0px" }}
                    >
                        <span
                            className="me-2"
                            onClick={() => {setRelease(release); setReleaseModalShow(true)}}
                            role="button"
                            tabIndex={0}
                            style={{ cursor: "pointer" }}
                            onKeyDown={(e) => { if (e.key === "Enter") {setRelease(release); setReleaseModalShow(true) }}}
                        >
                            <AssetSvg.Edit />
                        </span>
                    </button>) : (<></>)}
            </div>
            <ul className="list-unstyled m-0 p-0">
                {release.changes.map((change, index) => (
                    <li key={index} className="release-change w-100 d-flex">
                        <div className="type-container d-flex-inline"><div className={`type ${ChangelogChangeType[change.type]}`}>{ChangelogChangeType[change.type]}</div></div>
                        <p className="changelog-change-desc">{change.description}</p>

                    </li>
                ))}
            </ul>
        </div>
    )
}
